// Acukwik stores coordinates as degrees-dash-decimal-minutes ("N34-12.6" = 34° 12.6' = 34.21°),
// or occasionally as plain decimal degrees. Same decoding as the API's LocationHelper.
export const acukwikCoordinateToDegrees = (stored: string): number => {
    if (!stored) {
        return NaN;
    }
    const value = stored.trim();
    const hemisphere = value.charAt(0).toUpperCase();
    const maxDegrees = hemisphere === 'N' || hemisphere === 'S' ? 90 : 180;
    if (!'NSEW'.includes(hemisphere)) {
        const plain = Number(value);
        return Math.abs(plain) <= maxDegrees ? plain : NaN;
    }

    // A legacy DMS-shaped value ("W118-2900") would otherwise decode "successfully" to 166°, so the
    // minute field is range-checked instead of trusted.
    const [degrees, minutes] = value.substring(1).split('-');
    const wholeDegrees = Number(degrees);
    const decimalMinutes = Number(minutes);
    if (!degrees || !minutes || wholeDegrees < 0 || wholeDegrees > maxDegrees || decimalMinutes < 0 || decimalMinutes >= 60) {
        return NaN;
    }

    const decimalDegrees = wholeDegrees + decimalMinutes / 60;
    return hemisphere === 'S' || hemisphere === 'W' ? -decimalDegrees : decimalDegrees;
};
